import CustomSearchDropdown from 'components/common/CustomSearchDropdown/ver2';
import SizeBox from 'components/common/SizeBox';
import {
  getOccupationOptions,
  getPrevOccupationOptions,
} from 'components/common/func';
import {
  PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_FIELD,
  PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME,
  PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_FIELD,
  PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME,
} from 'features/pii/const';
import { Fade } from 'helpers/animation';
import useOccupation from 'hooks/occupation/useOccupation';
import useStore from 'hooks/useStore';
import { isBoolean } from 'lodash';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const CustomOccupationDropdown = ({
  information,
  validation,
  setInformation,
  setValidation,
  isShowRestOfOccupation,
}) => {
  const { state } = useStore();
  const { configOccupation } = state;

  const [occupations, setOccupations] = useState(null);

  const { checkShowPreviousOccupationField } = useOccupation();

  useEffect(() => {
    setOccupations({
      [PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME]:
        getOccupationOptions(configOccupation),
      [PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME]:
        getPrevOccupationOptions(
          information[PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME]?.key,
          configOccupation
        ),
    });
  }, [configOccupation, information]);

  const renderCustomSearchDropdown = (field) => (
    <CustomOccupationDropdownStyled>
      <CustomSearchDropdown
        field={field}
        data={occupations?.[field.name]}
        keyFind="key"
        keyTranslate="value"
        noResultText="form_text_no_result"
        information={information}
        setInformation={setInformation}
        validation={validation}
        setValidation={setValidation}
        styles={{
          marginBottom: 0,
        }}
      />
    </CustomOccupationDropdownStyled>
  );

  const renderOccupationDropdown = () => {
    return (
      <>
        {renderCustomSearchDropdown(
          PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_FIELD
        )}
      </>
    );
  };

  const isShowPreviousOccupationField = checkShowPreviousOccupationField(
    information[PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME]?.key
  );
  const renderPreviousOccupationDropdown = () => {
    if (isBoolean(isShowRestOfOccupation) && !isShowRestOfOccupation)
      return null;
    if (!isShowPreviousOccupationField) return null;
    return (
      <>
        <SizeBox height={16} />
        {renderCustomSearchDropdown(
          PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_FIELD
        )}
      </>
    );
  };

  return (
    <>
      {renderOccupationDropdown()}
      {renderPreviousOccupationDropdown()}
    </>
  );
};

const CustomOccupationDropdownStyled = styled.div`
  position: relative;
  width: 100%;
  ${Fade};
`;

export default CustomOccupationDropdown;
